/* Max Bassi — homepage interactions: scroll reveal + carousel arrows.
   Idempotent and safe to run on any page (no-ops when elements are absent). */
(function () {
  'use strict';

  function initReveal() {
    var items = document.querySelectorAll('.mb-reveal:not(.mb-in)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mb-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('mb-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  function initCarousels() {
    document.querySelectorAll('[data-mb-carousel-dir]').forEach(function (btn) {
      if (btn.dataset.mbBound) return;
      btn.dataset.mbBound = '1';
      btn.addEventListener('click', function () {
        var section = btn.closest('section') || document;
        var scroller = section.querySelector('[data-mb-scroller]');
        if (!scroller) return;
        var dir = parseInt(btn.getAttribute('data-mb-carousel-dir'), 10) || 1;
        scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  function init() {
    initReveal();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init in the Shopify theme editor when sections are re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
